import BlockComponentMap from '../../../models/BlockComponentValues/BlockComponentMap';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockContactData {
  html: BlockComponentMap;
  text: BlockComponentText;
  url?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockContactData {
  export function make(html?: string, text?: string, url?: string): BlockContactData {
    return {
      html: BlockComponentMap.make(html),
      text: text ? BlockComponentText.make(text) : undefined,
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(html: string = undefined, text = '***ここにお問い合わせが表示される***'): BlockContactData {
    return make(html, text);
  }
}

export default BlockContactData;
